export var quoteRequest = {
    "lease-details": {
        "preferred-lease-term": '',
        "preferred-lease-type": '',
        "preferred-rail-carrier": '',
        "preferred-rail-carrier-other": '',
        "rail-service-type": '',
        "preferred-lease-term-other": '',
        "min": '',
        "max": '',
        "city": '',
        "state": '',
        "country": '',
        "leaseableDate": '',
        "comments": '',
        "sds": [],
        "trinSight": true,
        "isValid": true,
    },
    "mechanical-options": {
        "covered-hopper": {
            "lining-requirements": '',
            "vibrator-brackets": '',
            "selected": false,
        },
        "general-service": {
            "air-valve-fitting": '',
            "air-valve-type": '',
            "bov-aux-valve": '',
            "bov-detail": '',
            "bov-gasket": '',
            "device-settings": '',
            "flange-gasket": '',
            "interior-prep": '',
            "interior_surface_prep": '',
            "lining-type": '',
            "liquid-valve-type": '',
            "loading-type": '',
            "manway-gasket": '',
            "manway-type": '',
            "need-sample_line": '',
            "need-thermowell": '',
            "nitrogen-psi": '',
            "o-ring": '',
            "oxygen-content": '',
            "platform-reqs": '',
            "special-reqs": '',
            "unloading-type": '',
            "selected": false,
        },
        "pressure-tank": {
            "device-settings": '',
            "flange-gasket": '',
            "interior-prep": '',
            "need-sample-line": '',
            "need-thermowell": '',
            "nitrogen-psi": '',
            "o-ring-required": '',
            "oxygen-content": '',
            "selected": false,
        },
        "isValid": false,
    }
}